import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { PipelineSettingsPanel } from '@/components/app/PipelineSettingsPanel';
import { Button } from '@/components/ui/button';

export interface PipelineVariablesPopupProps {
  open: boolean;
  onClose: () => void;
}

export const PipelineVariablesPopup: React.FC<PipelineVariablesPopupProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation('pipeline');
  // Close on Escape key
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="absolute inset-0 pointer-events-none z-30">
      <div className="h-full w-full flex justify-end">
        <div className="pointer-events-auto h-full w-full max-w-xl border-l border-border bg-background">
          <div className="h-14 border-b border-border flex items-center justify-between px-6">
            <div className="text-lg font-semibold">{t('variables.title')}</div>
            <Button variant="ghost" size="sm" onClick={onClose} aria-label={t('common:actions.close')}>
              ✕
            </Button>
          </div>
          <div className="p-6 overflow-auto h-[calc(100%-3.5rem)]">
            <PipelineSettingsPanel />
          </div>
        </div>
      </div>
    </div>
  );
};
